import React from 'react';
import ReactGA from 'react-ga';

import styles from './BookInfoBox.scss';
import ContentInfoBox from 'Components/ContentInfoBox';
import Button from 'Components/Button';

const BookInfoBox = ({
  title,
  author,
  buyLink,
  copyrightText,
  textLength,
  alternateLanguageVersions,
  slug,
}) => {
  let infoText = `<p>This ${
    textLength === 'Sample' ? 'book sample' : 'book'
  } is written by ${author}.</p>`;
  if (copyrightText) infoText += `<p>${copyrightText}</p>`;

  /* NOTE: TEMP HACK TO AVOID DISPLAYING BUY ICON / TEXT */
  const FREE_BOOKS = [
    'monster-maker',
    'no-fair',
    'body-chemistry',
    'newmon',
    'all-phone-and-games',
    'lion-queen',
    'diary-of-a-wimpy-kid-how-to-survive-annoying-brothers',
    'diary-of-a-wimpy-kid-how-to-survive-funny-friends',
    'diary-of-a-wimpy-kid-how-to-survive-problem-pets',
    'diary-of-a-wimpy-kid-how-to-survive-school-disasters',
    'diary-of-a-wimpy-kid-survival-activity-book',
    'diary-of-a-wimpy-kid-survival-guide',
  ];

  const isFreeBook = FREE_BOOKS.includes(slug);

  const onButtonClick = e => {
    ReactGA.event({
      category: 'Buy Book Button',
      action: 'click',
      label: title,
    });
  };

  const buyButton = buyLink ? (
    <Button
      externalLink={buyLink}
      buttonSize="hero"
      buttonContext={!isFreeBook && 'buy'}
      withAction
      text={isFreeBook ? 'Download' : 'Buy Book'}
      clickHandler={onButtonClick}
      customClass=" BookInfoBox__button"
    />
  ) : null;

  return (
    <ContentInfoBox
      actionButton={buyButton}
      headline="Book Info"
      body={infoText}
      extraClass=" BookInfoBox"
      alternateLanguageVersions={alternateLanguageVersions}
    />
  );
};

export default BookInfoBox;
